import { instanceForBackend } from '../../config/axios.config';
import { BACKEND_API } from '../../constants/backendApi';
export var extraSettingsService = {
    getExtraSettings: function (shopId) {
        return instanceForBackend.get("".concat(BACKEND_API.SETTINGS, "/").concat(shopId));
    },
    createExtraSettings: function (data) {
        return instanceForBackend.post(BACKEND_API.SETTINGS, data);
    },
    updateExtraSettings: function (data) {
        return instanceForBackend.put("".concat(BACKEND_API.SETTINGS, "/").concat(data.shop_id), data);
    },
};
